"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));
var _NotifyIcon = _interopRequireDefault(require("../NotifyIcon"));
var _CustomTreeViewStyles = require("./CustomTreeViewStyles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var TreeItem = function TreeItem(_ref) {
  var node = _ref.node,
    selectedItems = _ref.selectedItems,
    handleSelection = _ref.handleSelection;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var isSelected = selectedItems.includes(node.id);
  var handleToggle = function handleToggle(e) {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };
  var handleCheck = function handleCheck(e) {
    e.stopPropagation();
    handleSelection(node.id, e.target.checked);
  };
  var handleKeyPress = function handleKeyPress(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      handleToggle();
    }
  };
  var ShowName = function ShowName() {
    var chevronIcon = isOpen ? /*#__PURE__*/_react["default"].createElement(_NotifyIcon["default"], {
      iconName: "chevronDown",
      fontSize: "20px"
    }) : /*#__PURE__*/_react["default"].createElement(_NotifyIcon["default"], {
      iconName: "chevronRight",
      fontSize: "default"
    });
    var iconWithBackground = node.icon && /*#__PURE__*/_react["default"].createElement(_CustomTreeViewStyles.IconbackgroundCircleStyle, {
      style: {
        backgroundColor: node.iconBackgroundStyle
      }
    }, /*#__PURE__*/_react["default"].createElement(_NotifyIcon["default"], {
      color: node.iconColor,
      iconName: node.icon,
      onMouseDown: function onMouseDown(event) {
        return event.stopPropagation();
      }
    }));
    return /*#__PURE__*/_react["default"].createElement("div", null, node.children && chevronIcon, iconWithBackground, /*#__PURE__*/_react["default"].createElement("span", null, node.name));
  };
  return /*#__PURE__*/_react["default"].createElement(_CustomTreeViewStyles.TreeItemWrapper, null, /*#__PURE__*/_react["default"].createElement(_CustomTreeViewStyles.TreeItemLabel, null, !node.children && /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    checked: isSelected,
    onChange: handleCheck
  }), /*#__PURE__*/_react["default"].createElement("div", {
    role: "button",
    tabIndex: "0",
    onKeyDown: handleKeyPress,
    onClick: handleToggle,
    style: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer'
    }
  }, ShowName())), isOpen && node.children && /*#__PURE__*/_react["default"].createElement(_CustomTreeViewStyles.TreeList, null, node.children.map(function (childNode) {
    return /*#__PURE__*/_react["default"].createElement(TreeItem, {
      key: childNode.id,
      node: childNode,
      selectedItems: selectedItems,
      handleSelection: handleSelection
    });
  })));
};
TreeItem.propTypes = {
  node: _propTypes["default"].shape({
    id: _propTypes["default"].number.isRequired,
    icon: _propTypes["default"].string,
    iconColor: _propTypes["default"].string,
    iconBackgroundStyle: _propTypes["default"].string,
    name: _propTypes["default"].string.isRequired,
    children: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
  }).isRequired,
  selectedItems: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  handleSelection: _propTypes["default"].func.isRequired
};
var CustomTreeView = function CustomTreeView(_ref2) {
  var data = _ref2.data;
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedItems = _useState4[0],
    setSelectedItems = _useState4[1];
  var handleSelection = function handleSelection(id, isChecked) {
    setSelectedItems(function (prevSelectedItems) {
      var newSelectedItems = new Set(prevSelectedItems);
      var handleChildSelection = function handleChildSelection(node, check) {
        if (check) {
          newSelectedItems.add(node.id);
        } else {
          newSelectedItems["delete"](node.id);
        }
        if (node.children) {
          node.children.forEach(function (child) {
            return handleChildSelection(child, check);
          });
        }
      };
      var currentNode = data.find(function (node) {
        return node.id === id;
      });
      handleChildSelection(currentNode, isChecked);
      return Array.from(newSelectedItems);
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_CustomTreeViewStyles.TreeList, null, data.map(function (node) {
    return /*#__PURE__*/_react["default"].createElement(TreeItem, {
      key: node.id,
      node: node,
      selectedItems: selectedItems,
      handleSelection: handleSelection
    });
  }));
};
CustomTreeView.propTypes = {
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].number.isRequired,
    icon: _propTypes["default"].string,
    iconColor: _propTypes["default"].string,
    iconBackgroundStyle: _propTypes["default"].string,
    name: _propTypes["default"].string.isRequired,
    children: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
  })).isRequired
};
var _default = exports["default"] = CustomTreeView;